import { ReactComponent as ActionPlansIcon } from '../assets/icons/assignment.svg';
import { ReactComponent as OneOnOneIcon } from '../assets/icons/people.svg';
import { ReactComponent as NotesIcon } from '../assets/icons/public-note-icon.svg';
import { ReactComponent as DocumentsIcon } from '../assets/icons/description.svg';
import { ACTION_PLAN_FIELDS } from './actionPlan';

export const NOTIFICATION_MODELS = {
  ACTION_PLAN: 'Plan',
  DOCUMENT: 'Document',
  NOTE: 'UserNote',
  ONE_ON_ONE: 'OneOnOne',
};

export const NOTIFICATION_MODEL_KEYS = {
  ACTION_PLAN: 'actionPlan',
  DOCUMENT: 'document',
  NOTE: 'note',
  ONE_ON_ONE: 'oneOnOne',
};

export const NOTIFICATION_MODELS_MAP = [
  {
    value: NOTIFICATION_MODELS.NOTE,
    key: NOTIFICATION_MODEL_KEYS.NOTE,
  },
  {
    value: NOTIFICATION_MODELS.ONE_ON_ONE,
    key: NOTIFICATION_MODEL_KEYS.ONE_ON_ONE,
  },
  {
    value: NOTIFICATION_MODELS.ACTION_PLAN,
    key: NOTIFICATION_MODEL_KEYS.ACTION_PLAN,
  },
  {
    value: NOTIFICATION_MODELS.DOCUMENT,
    key: NOTIFICATION_MODEL_KEYS.DOCUMENT,
  },
];

export const NOTIFICATION_ROUTES = {
  actionPlan: 'action-plans',
  notes: 'notes',
  oneOnOne: '1-1',
  documents: 'documents',
};

export const NOTIFICATION_ACTIONS = {
  CREATE: 'create',
  UPDATE: 'update',
  EXPIRATION: 'expiration',
};

export const NOTIFICATION_ACTIONS_MAP = [
  {
    value: 'NEW',
    key: NOTIFICATION_ACTIONS.CREATE,
  },
  {
    value: 'UPDATE',
    key: NOTIFICATION_ACTIONS.UPDATE,
  },
  {
    value: 'EXPIRATION',
    key: NOTIFICATION_ACTIONS.EXPIRATION,
  },
];

export const NOTIFICATION_CREATE_ACTIONS = {
  ACTION_PLAN: 'createdPlan',
  NOTE: 'createdNote',
  ONE_ON_ONE: 'createdOneOnOne',
};

export const TEAM_NOTIFICATION_UPDATE_FIELDS = {
  actionPlan: {
    [ACTION_PLAN_FIELDS.TITLE]: 'title',
    [ACTION_PLAN_FIELDS.DUE_DATE]: 'dueDate',
    [ACTION_PLAN_FIELDS.STATUS]: 'status',
    [ACTION_PLAN_FIELDS.PROGRESS]: 'completeness',
    [ACTION_PLAN_FIELDS.TAGS]: 'tags',
    [ACTION_PLAN_FIELDS.COURSES]: 'courses',
    [ACTION_PLAN_FIELDS.DESCRIPTION]: 'description',
    [ACTION_PLAN_FIELDS.TASKS]: 'tasks',
    [NOTIFICATION_CREATE_ACTIONS.ACTION_PLAN]:
      NOTIFICATION_CREATE_ACTIONS.ACTION_PLAN,
  },
  note: {
    text: 'text',
    tasks: 'tasks',
    tags: 'tags',
    [NOTIFICATION_CREATE_ACTIONS.NOTE]: NOTIFICATION_CREATE_ACTIONS.NOTE,
  },
  oneOnOne: {
    meeting_time: 'meetingTime',
    meeting_date_and_time: 'meetingDateTime',
    meeting_date: 'meetingDate',
    recurring: 'recurring',
    tags: 'tags',
    tasks: 'tasks',
    agenda: 'agenda',
    employee_agenda: 'employeeAgenda',
    plans: 'plans',
    meeting_impression: 'meetingImpression',
    [NOTIFICATION_CREATE_ACTIONS.ONE_ON_ONE]:
      NOTIFICATION_CREATE_ACTIONS.ONE_ON_ONE,
  },
};

export const NOTIFICATION_MODEL_ICONS = {
  actionPlan: ActionPlansIcon,
  note: NotesIcon,
  oneOnOne: OneOnOneIcon,
  document: DocumentsIcon,
};

export const NOTIFICATION_ITEM_SIZE = 84;

export const NOTIFICATION_ITEM_BORDER = 1;

export const NOTIFICATIONS_VISIBLE_COUNT = 4;

export const NOTIFICATION_LIST_GAP = 8;
